import Provider from '@/types/purchaseRequest/provider'
import { BaseService } from './../../base'
export class ProviderService extends BaseService<Provider>() {
    static get entity (): string {
        return 'provider'
    }
    static get responseName (): string {
        return 'provider'
    }
}